import LazyLoad from "vanilla-lazyload";
import Faq from "../blocks/faq";
import "selectric";

const Common = {
  lazyload: null,

  init() {
    this.lazyload = new LazyLoad({});

    Common.events();

    new Faq(".faq-block");
    $(".service-filter__items").find("select").selectric({
      inheritOriginalWidth: true,
    });
  },

  events() {
    $(".seo-read-more").on("click", function (e) {
      $(this).parent().find(".content-hidden").toggleClass("show");
    });

    $("body").on("click", ".open-gallery-close", function (e) {
      $("html").removeClass("no-scroll");
      $(".gallery--open").remove();
    });
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        $("html").removeClass("no-scroll");
        $(".gallery--open").remove();
      }
    });
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Video.
    $("#playBtn").on("click", function () {
      console.log("holla");

      $(this)
        .parent()
        .parent()
        .addClass("playing")
        .find("#videoBlock")[0]
        .play();
    });

    $(".video__overlay").on("click", function () {
      $(this).parent().toggleClass("playing").find("#videoBlock")[0].pause();
    });

    // Accordion
    $("body").on("click", ".accordion", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    $("body").on("click", ".btn-less", function () {
      $(this).parent().slideToggle().prev().toggleClass("active");
    });

    //Accordion mobile menu
    $(".accordion-mob").on("click", function () {
      if ($(this).parent().hasClass("active")) {
        $(this).parent().removeClass("active").next().slideUp();
      } else {
        $(".accordion-mob").parent().removeClass("active").next().slideUp();
        $(this).parent().addClass("active").next().slideDown();
      }
    });

    // SEO
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }

      $(this).toggleClass("active");
    });

    //Tabs
    $(".tab-content").not('[data-container="1"]').hide();

    $(".tab-button").click(function () {
      var targetTab = $(this).data("target");

      $(".tab-content").hide();
      $('[data-container="' + targetTab + '"]').show();

      $(".tab-button").removeClass("active");
      $(this).addClass("active");
    });

    $('[data-target="1"]').addClass("active");
  },
};

export default Common;
